import uiparam from "./uiparam";

export default [
  uiparam
]



// WEBPACK FOOTER //
// ./src/store/platform/index.js